// Configuración de características de membresía según la tabla de requerimientos
// Este archivo define qué características están disponibles para cada rol y plan

export const MEMBERSHIP_FEATURES = {
  // Características para Miembros (Doctores)
  MEMBER: {
    // Características disponibles en plan FREE
    FREE: [
      'profile_creation',           // Creación de perfil
      'virtual_consultation',       // Uso de consultorio virtual
      'epayco_payment',            // Uso epayco
      'revive_free_courses'        // Acceso a los cursos Gratuitos de revive
    ],
    
    // Características adicionales en plan PREMIUM
    PREMIUM: [
      'salutio_logo_usage',        // Uso de logo de Salutio Red
      'allies_access',             // Ingreso a los aliados
      'profile_visibility',        // Perfil visible a los usuarios
      'tech_features'              // usos teconologicos (chat bot, agenda en celular)
    ]
  },

  // Características para Usuarios (Pacientes)
  USER: {
    // Características disponibles en plan FREE
    FREE: [
      'professional_directory',     // Acceso al directorio de profesionales
      'virtual_consultation_user'  // Uso del consultorio virtual
    ],
    
    // Características adicionales en plan PREMIUM
    PREMIUM: [
      'allies_benefits',           // Acceso a lo aliados para tener sus beneficios
      'tech_features_user'         // usos teconologicos (chat bot, agenda en celular)
    ]
  }
};

// Función para obtener todas las características disponibles para un rol y plan
export const getFeaturesForRoleAndPlan = (role, plan) => {
  const roleFeatures = MEMBERSHIP_FEATURES[role];
  if (!roleFeatures) return [];

  const freeFeatures = roleFeatures.FREE || [];
  const premiumFeatures = roleFeatures.PREMIUM || [];

  if (plan === 'premium') {
    return [...freeFeatures, ...premiumFeatures];
  }

  return freeFeatures;
};

// Función para verificar si una característica está disponible para un rol y plan
export const hasFeatureAccess = (role, plan, feature) => {
  const availableFeatures = getFeaturesForRoleAndPlan(role, plan);
  return availableFeatures.includes(feature);
};

// Función para obtener características premium de un rol
export const getPremiumFeaturesForRole = (role) => {
  const roleFeatures = MEMBERSHIP_FEATURES[role];
  return roleFeatures?.PREMIUM || [];
};

// Función para obtener características gratuitas de un rol
export const getFreeFeaturesForRole = (role) => {
  const roleFeatures = MEMBERSHIP_FEATURES[role];
  return roleFeatures?.FREE || [];
};

// Descripciones de características para mostrar en la UI
export const FEATURE_DESCRIPTIONS = {
  // Miembros (Doctores)
  profile_creation: {
    title: 'Creación de Perfil',
    description: 'Crear y gestionar tu perfil profesional',
    icon: '👤'
  },
  virtual_consultation: {
    title: 'Consultorio Virtual',
    description: 'Realizar consultas médicas virtuales',
    icon: '🩺'
  },
  epayco_payment: {
    title: 'Pagos con ePayco',
    description: 'Procesar pagos usando ePayco',
    icon: '💳'
  },
  revive_free_courses: {
    title: 'Cursos Gratuitos Revive',
    description: 'Acceso a cursos gratuitos de Revive',
    icon: '📚'
  },
  salutio_logo_usage: {
    title: 'Logo de Redplika',
    description: 'Usar el logo oficial de Redplika',
    icon: '🏥'
  },
  allies_access: {
    title: 'Acceso a Aliados',
    description: 'Ingresar a la red de aliados comerciales',
    icon: '🤝'
  },
  profile_visibility: {
    title: 'Visibilidad de Perfil',
    description: 'Tu perfil será visible para los usuarios',
    icon: '👁️'
  },
  tech_features: {
    title: 'Características Tecnológicas',
    description: 'Chat bot y agenda móvil',
    icon: '🤖'
  },

  // Usuarios (Pacientes)
  professional_directory: {
    title: 'Directorio de Profesionales',
    description: 'Acceso completo al directorio de profesionales',
    icon: '📋'
  },
  virtual_consultation_user: {
    title: 'Consultorio Virtual',
    description: 'Participar en consultas médicas virtuales',
    icon: '🩺'
  },
  allies_benefits: {
    title: 'Beneficios de Aliados',
    description: 'Acceso a beneficios de aliados comerciales',
    icon: '🎁'
  },
  tech_features_user: {
    title: 'Características Tecnológicas',
    description: 'Chat bot y agenda móvil para pacientes',
    icon: '🤖'
  }
};

// Planes disponibles
export const AVAILABLE_PLANS = {
  FREE: {
    id: 'free',
    name: 'Gratuito',
    price: 0,
    currency: 'USD',
    description: 'Acceso básico a las funcionalidades principales',
    features: ['Acceso limitado', 'Funcionalidades básicas'],
    color: 'gray'
  },
  PREMIUM: {
    id: 'premium',
    name: 'Premium',
    price: 29.99,
    currency: 'USD',
    period: 'monthly',
    description: 'Acceso completo a todas las funcionalidades',
    features: ['Acceso completo', 'Todas las características', 'Soporte prioritario'],
    color: 'yellow',
    popular: true
  }
};

// Configuración de roles
export const USER_ROLES = {
  MEMBER: {
    name: 'Miembro',
    description: 'Profesionales de la salud (doctores, especialistas)',
    icon: '👨‍⚕️'
  },
  USER: {
    name: 'Usuario',
    description: 'Pacientes y usuarios finales',
    icon: '👤'
  }
};

export default {
  MEMBERSHIP_FEATURES,
  getFeaturesForRoleAndPlan,
  hasFeatureAccess,
  getPremiumFeaturesForRole,
  getFreeFeaturesForRole,
  FEATURE_DESCRIPTIONS,
  AVAILABLE_PLANS,
  USER_ROLES
}; 